// F6_2 Tab切换2
import { FC, useMemo, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { SwiperSlide } from 'swiper/react'
import { Swiper as SwiperClass } from 'swiper/types'
import { ITabSwiperCard, paddingTopClassMap, paddingBottomClassMap } from '../../../../common/pd-meta-components-types'
import PdMedia from '../../../pd-media/pd-media'
import PdSwiper from '../../../pd-swiper/pd-swiper'
import styles from './tab-swiper.module.scss'
import TitleAndDesc from '../../title-and-desc'

const TabSwiper: FC<ITabSwiperCard> = ({ theme, title, desc, mediaUrlList, tabPanels, paddingTop = 'px120', paddingBottom = 'px120' }) => {
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass | null>(null)
  const [tabIndex, setTabIndex] = useState<number>(0)

  const noTab = useMemo(() => {
    return !tabPanels || tabPanels.length <= 0
  }, [tabPanels])

  function onTabSelect(index: number, lastIndex: number) {
    if (swiperInstance) {
      swiperInstance.slideTo(index)
    }
  }

  function onSwiperSlideChange(swiper: SwiperClass) {
    const currentSlideIndex = swiper.activeIndex
    setTabIndex(currentSlideIndex)
  }

  return (
    <section
      className={[
        styles['pd-meta-tab-swiper'],
        'w-full flex flex-col items-center',
        paddingTopClassMap[paddingTop],
        paddingBottomClassMap[paddingBottom],
        `pd-theme-${theme}`,
      ].join(' ')}
    >
      <TitleAndDesc title={title} desc={desc} />
      <div className={['max-w-300 w-full', 'h-330px laptop:h-150', 'px-6 laptop:px-0'].join(' ')}>
        <PdSwiper
          hideNavigation={!noTab}
          hidePagination={!noTab}
          onSwiper={(swiper) => setSwiperInstance(swiper)}
          onSlideChange={(swiper) => onSwiperSlideChange(swiper)}
        >
          {mediaUrlList?.map((url, index) => (
            <SwiperSlide key={index}>
              <PdMedia src={url} mask={false} />
            </SwiperSlide>
          ))}
        </PdSwiper>
      </div>

      {!noTab && (
        <Tabs selectedIndex={tabIndex} onSelect={(index: number, lastIndex: number) => onTabSelect(index, lastIndex)}>
          <TabList>
            {tabPanels?.map((tp) => (
              <Tab key={tp.tab}>{tp.tab}</Tab>
            ))}
          </TabList>
          {tabPanels?.map((tp) => (
            <TabPanel key={tp.tab}>{tp.panel}</TabPanel>
          ))}
        </Tabs>
      )}
    </section>
  )
}

export default TabSwiper
